import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import dayJs from 'dayjs';

import { appConfig } from '@app/app';

interface WatchlistHeaderProps {
  generatedAt?: string;
}

// Shared by WatchlistPanel (empty/failed states) and WatchlistList (filled state) — one heading +
// timestamp row, never re-implemented per state. Its own file so the two don't import each other
// (`import/no-cycle` is on, and `lint-staged` runs `--max-warnings=0`).
export const WatchlistHeader = ({ generatedAt }: WatchlistHeaderProps) => {
  const { t } = useTranslation('common');

  return (
    <>
      <Typography variant="h2">{t('application.watchlist.title')}</Typography>
      <Typography variant="subtitle1" sx={{ mt: 1, mb: 3, fontWeight: 600, color: 'text.secondary' }}>
        {t('application.watchlist.generatedOn', {
          date: generatedAt ? dayJs(generatedAt).format(appConfig.format.date) : '',
        })}
      </Typography>
    </>
  );
};
